import React, { useState, useEffect, useMemo } from 'react'
import './styles.css'
import { Button, Col, Divider, Form, Input, Popconfirm, Row, Select, Space, message } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { instituicaoEncaminhamentoService } from '../../services/Instituicao-Encaminhamento-Service/instituicao-encaminhamento-service';

interface inputSelectInstituicaoEncaminhamentoProp {
    instituicaoEncaminhamentoID?: number,
    visibleModal?: any,
}

const InputSelectInstituicaoEncaminhamento: React.FC<inputSelectInstituicaoEncaminhamentoProp> = (prop) => {

    const [formInstituicaoEncaminhamento] = Form.useForm();
    const [instituicaoEncaminhamento, setInstituicaoEncaminhamento] = useState<any[]>();
    const [visibilityInput, setVisibilityInput] = useState<boolean>(false);
    const [ehGestor, setEhGestor] = useState<boolean>(false)
    const [rolagemCompleta, setRolagemCompleta] = useState<boolean>(false)

    useEffect(() => {
        instituicaoEncaminhamentoService.getAll().then((resp) => {
            if (resp.status == 200) {
                setInstituicaoEncaminhamento(resp.data.filter((i: any) => i.ativo == true))
                if(resp.data.filter((i: any) => i.ativo == true).length == 0){
                    setRolagemCompleta(true)
                }
            }
        })
        validarEhGestor()
    }, [])

    useMemo(() => {
        setVisibilityInput(false)
        formInstituicaoEncaminhamento.resetFields()
    }, [prop.visibleModal])

    const validarEhGestor = () => {
        var grupoLogado = parseInt(sessionStorage.getItem('grupoID') || "")
        if (grupoLogado == 1330 || grupoLogado == 1334 || grupoLogado == 1336)
            setEhGestor(true)
        else
            setEhGestor(false)
    }

    function addInstituicaoEncaminhamento() {
        let instituicaoEncaminhamento = {
            descricao: formInstituicaoEncaminhamento.getFieldValue("descricao")
        }

        instituicaoEncaminhamentoService.post(instituicaoEncaminhamento)
            .then((resp) => {
                message.success("Instituição Encaminhamento adicionado com sucesso")
                formInstituicaoEncaminhamento.resetFields()
                setVisibilityInput(false)
            })
            .finally(() => {
                instituicaoEncaminhamentoService.getAll().then((resp) => {
                    if (resp.status == 200) {
                        setInstituicaoEncaminhamento(resp.data.filter((i: any) => i.ativo == true))
                    }
                })
            })
            .catch((err) => {
                message.error(err.response.data.error[0] || "Erro inesperado")
                formInstituicaoEncaminhamento.resetFields()
                setVisibilityInput(false)
            })
    }

    function handlePopupScroll(event: any) {
        const element = event.target;
        const scrollPosition = element.scrollHeight - element.scrollTop;
        const elementHeight = element.clientHeight;

        if (scrollPosition >= elementHeight) {
            setRolagemCompleta(true)
        }
    }


    return (
        <Form.Item name="instituicaoEncaminhamentoID" label="Instituição Encaminhamento" >
            <Select showSearch
                listHeight={160}
                onPopupScroll={handlePopupScroll}
                filterOption={(input, option) => {
                    return (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                }
                }
                filterSort={(optionA, optionB) => {
                    return (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                }
                }
                placeholder="Selecione a Instituição de Encaminhamento" dropdownRender={menu => (
                    <>
                        {menu}
                        {
                            ehGestor ?
                                <>
                                    < Divider style={{ margin: '8px 0' }} />
                                    <Form form={formInstituicaoEncaminhamento} style={{ marginBottom: '-15px' }} className='descricaoAreaCadastro'>
                                        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                                            {visibilityInput && rolagemCompleta ?
                                                <Col span={16}>
                                                    <Form.Item name="descricao" >
                                                        <Input
                                                            placeholder="Digite a descrição"
                                                            id='descricaoInstituicaoEncaminhamento'
                                                            type='text'
                                                        />
                                                    </Form.Item>
                                                </Col> : null}
                                            <Col span={8}>
                                                <Form.Item >
                                                    {(visibilityInput && rolagemCompleta) ?
                                                        <Popconfirm placement='bottom' title="Deseja realmente adicionar essa Instituição de Encaminhamento?" onConfirm={addInstituicaoEncaminhamento} onCancel={() => { setVisibilityInput(false); formInstituicaoEncaminhamento.resetFields() }} >
                                                            <Button type="primary" htmlType='button' icon={<PlusOutlined />} >
                                                                Salvar
                                                            </Button>
                                                        </Popconfirm> :
                                                        <Button type="primary" htmlType='button' onClick={() => { if (!visibilityInput) { setVisibilityInput(true) } }} icon={<PlusOutlined />} >
                                                            Adicionar
                                                        </Button>}
                                                </Form.Item>
                                            </Col>
                                        </Row>
                                    </Form>
                                </>
                                : null
                        }

                    </>)}
                options={instituicaoEncaminhamento?.map((m) => ({ label: m?.descricao, value: m?.instituicaoEncaminhamentoID }))}>
            </Select >
        </Form.Item>
    )
}

export default InputSelectInstituicaoEncaminhamento